import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { createImpactReportQuery } from "./options";

/**
 * Warms the report while the pointer is on its way to the button. Repeat hovers cost nothing:
 * `prefetchQuery` honours the query's `staleTime` and no-ops on a fresh entry.
 */
export const usePrefetchImpactReport = () => {
    const queryClient = useQueryClient();

    return useCallback(() => {
        void queryClient.prefetchQuery(createImpactReportQuery());
    }, [queryClient]);
};
